import { FaCoins, FaFacebookF, FaInstagram, FaWhatsapp, FaLinkedinIn, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="lf-footer">
      <div className="container lf-footer__grid">
        <div className="lf-footer__brand">
          <div className="lf-footer__logo">
            <span className="lf-footer__logo-icon">
              {/* <FaCoins /> */}
              <img src="/lintlogoco.png" alt="Lint Logo" />
            </span>
            <span>
              LENT <em>FINANCE</em>
            </span>
          </div>
          <p>
            Trusted financial services with transparent policies and quick loan
            approvals — serving families and businesses across Kerala.
          </p>
          <div className="lf-footer__socials">
            <a href="#" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" aria-label="Instagram"><FaInstagram /></a>
            <a href="#" aria-label="WhatsApp"><FaWhatsapp /></a>
            <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
          </div>
        </div>

        <div className="lf-footer__col">
          <h4>Quick Links</h4>
          <button onClick={() => scrollTo("home")}>Home</button>
          <button onClick={() => scrollTo("about")}>About Us</button>
          <button onClick={() => scrollTo("services")}>Services</button>
          <button onClick={() => scrollTo("contact")}>Contact</button>
        </div>

        <div className="lf-footer__col">
          <h4>Contact Info</h4>
          <p><FaMapMarkerAlt /> Deepam Square, Chittur Road, Kadamkode, Karingarapully, Palakkad - 678551</p>
          <p><FaPhoneAlt /> 0491-2080455 / 70346 44555</p>
          <p><FaEnvelope /> Lentfinance@gmail.com</p>
        </div>
      </div>

      <div className="lf-footer__bottom container">
        <span>© {year} LENT FINANCE. All rights reserved.</span>
        <span>KML NO : 32090439159</span>
      </div>
    </footer>
  );
};

export default Footer;
